import type { Posting } from "@/lib/api/catalogue";
import { actionProps } from "@/lib/controlAnalytics";
import { postingPageName } from "@/lib/posting/page";
import { ROUTES } from "@/lib/routes";
import { RESUME_CHECK_COPY } from "@/lib/tools/copy";

const POSTING_LEDE =
    "Paste your resume. See which of this job's keywords it names, and which it does not. Free. No sign-up.";

const CRUMB = "font-medium hover:text-brand-ink";

/**
 * Where the tool is, and what it does. Its links are plain `<a href>`: a
 * tool's address loads as a new page, so no ad tag is left running (lib/ads).
 */
export default function CheckHeading({
    posting,
    settled,
}: {
    posting: Posting | null;
    /** A result is up, so the lede has done its work. */
    settled: boolean;
}) {
    return (
        <div className="mb-5 flex flex-col gap-2">
            <nav
                aria-label="Breadcrumb"
                className="flex min-w-0 flex-wrap items-center gap-1.5 text-ui text-fg-muted"
            >
                <a
                    {...actionProps("navigation_clicked", {
                        source: "ResumeCheck",
                        target: ROUTES.TOOLS,
                    })}
                    href={ROUTES.TOOLS}
                    className={CRUMB}
                >
                    Tools
                </a>
                <span className="text-fg-faint">/</span>
                {posting ? (
                    <a
                        {...actionProps("navigation_clicked", {
                            source: "ResumeCheck",
                            target: ROUTES.RESUME_CHECK,
                        })}
                        href={ROUTES.RESUME_CHECK}
                        className={CRUMB}
                    >
                        Resume keyword checker
                    </a>
                ) : (
                    <span aria-current="page" className="font-medium">
                        Resume keyword checker
                    </span>
                )}
            </nav>
            <h1 className="m-0 font-display text-page-title font-bold tracking-[-0.025em] [overflow-wrap:anywhere] [text-wrap:balance]">
                {posting
                    ? `See what your resume is missing for ${postingPageName(posting)}`
                    : RESUME_CHECK_COPY.heading}
            </h1>
            {!settled && (
                <p className="m-0 text-read text-fg-muted [text-wrap:pretty]">
                    {posting ? POSTING_LEDE : RESUME_CHECK_COPY.lede}
                </p>
            )}
        </div>
    );
}
